import axios, { AxiosResponse } from 'axios';

import {
  AbandonedCartParams,
  AbandonedCartRes,
} from '@src/types/abandonedCart.ts';

export const getAbandonedCarts = (
  params?: AbandonedCartParams
): Promise<AxiosResponse<AbandonedCartRes>> => {
  return axios.get('/abandoned-carts/', { params });
};